import { useCallback, useRef, useState } from 'react';

const MAX_STACK = 50;

export const useUndoRedo = () => {
  const [past, setPast] = useState([]);
  const [future, setFuture] = useState([]);
  const executingRef = useRef(false);

  const pushCommand = useCallback((command) => {
    if (executingRef.current || !command) return;
    setPast((prev) => [...prev.slice(-MAX_STACK + 1), command]);
    setFuture([]);
  }, []);

  const undo = useCallback(async () => {
    if (past.length === 0) return;
    const command = past[past.length - 1];
    executingRef.current = true;
    try {
      await command.revert?.();
      setPast((prev) => prev.slice(0, -1));
      setFuture((prev) => [command, ...prev]);
    } finally {
      executingRef.current = false;
    }
  }, [past]);

  const redo = useCallback(async () => {
    if (future.length === 0) return;
    const command = future[0];
    executingRef.current = true;
    try {
      await command.execute?.();
      setFuture((prev) => prev.slice(1));
      setPast((prev) => [...prev, command]);
    } finally {
      executingRef.current = false;
    }
  }, [future]);

  return {
    canUndo: past.length > 0,
    canRedo: future.length > 0,
    pushCommand,
    undo,
    redo,
  };
};

export default useUndoRedo;
